import * as Yup from "yup";

export const loginSchema = Yup.object({
  polHolderName: Yup.string()
    .min(2, "Name must be greater than 2 character")
    .max(25, "Name must be less than 25 character")
    .trim()
    .test("is-not-empty-or-space", "Name cannot be empty.", (value: any) => value && value.trim().length > 0)
    .matches(/^[^0-9]*$/, "Name cannot contain numbers")
    .required("Name is required!"),
  polHolderEmail: Yup.string()
    .trim()
    .matches(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/, "Please enter a valid Email")
    .required("Email is required!"),
  polHolderPhone: Yup.string()
    .matches(/^[6789]\d{9}$/, "Please Enter a valid mobile number")
    .required("Mobile number is required!")
});

export const lifeValidation = Yup.object().shape({
  POLYFYX_QB2: Yup.boolean().required(),
  POLYFYX_QB2_2: Yup.object().when("POLYFYX_QB2", {
    is: (value: any) => value === true,
    then: (schema: any) =>
      schema.shape({
        PolicyNumber: Yup.string().required("Policy Number is required"),
        SumInsured: Yup.number().required("Sum Insured is required"),
        InsuranceCompanyName: Yup.string().required("Select insurance company name")
      }),
    otherwise: (schema: any) => schema.notRequired()
  }),
  POLYFYX_QC1: Yup.boolean().required(),
  POLYFYX_QC1_2: Yup.object().when("POLYFYX_QC1", {
    is: (value: any) => value === true,
    then: (schema: any) =>
      schema.shape({
        PolicyNumber: Yup.string().required("Policy Number is required"),
        SumInsured: Yup.number().required("Sum Insured is required"),
        InsuranceCompanyName: Yup.string().required("Select insurance company name")
      }),
    otherwise: (schema: any) => schema.notRequired()
  }),
  POLYFYX_QF2: Yup.boolean().required(),
  POLYFYX_QF2_2: Yup.object().when("POLYFYX_QF2", {
    is: (value: any) => value === true,
    then: (schema: any) =>
      schema.shape({
        Occupation: Yup.string().required("Please specify the occupation")
      }),
    otherwise: (schema: any) => schema.notRequired()
  }),
  POLYFYX_QC3: Yup.boolean().required(),
  POLYFYX_QC3_1: Yup.object().when("POLYFYX_QC3", {
    is: (value: any) => value === false,
    then: (schema: any) =>
      schema.shape({
        MobileNumber: Yup.string()
          .required("Mobile Number is required")
          .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number")
      }),
    otherwise: (schema: any) => schema.notRequired()
  })
});
